import { render, staticRenderFns } from "./PercentualFaturamentoChart.vue?vue&type=template&id=789fb8ab"
import script from "./PercentualFaturamentoChart.vue?vue&type=script&lang=js"
export * from "./PercentualFaturamentoChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports